import { _ as __awaiter, a as __generator } from '../_tslib-6fadb982.js';
import qs from 'qs';
import environment from '../environment/index.js';
import cookie from '../cookie/index.js';
import axios from 'axios';

var http = axios.create();
// let getTokenLoading = false
var token = {
    getTokenLoading: false,
    getVisitTokenLoading: false,
    getVisitToken: function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getVisitTokenLoading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sleep(10)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.getVisitToken(options)];
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var env = environment.getEnv();
                            var apigateway = environment.getApigateWay();
                            var AccessVisittoken = cookie.getCookie("AccessVisittoken");
                            if (!AccessVisittoken) {
                                _this.getVisitTokenLoading = true;
                                http.get(apigateway + "/api/v1/token/get?AppID=" + options.AppID + "&GDSSID=" + options.GDSSID).then(function (result) {
                                    _this.getVisitTokenLoading = false;
                                    if (result.data.status == 0) {
                                        cookie.setCookie("AccessVisittoken", result.data.result, 3600);
                                        resolve(result.data.result);
                                    }
                                    else {
                                        reject(result);
                                    }
                                }, function (error) {
                                    _this.getVisitTokenLoading = false;
                                    reject(error);
                                });
                            }
                            else {
                                resolve(cookie.getCookie("AccessVisittoken"));
                            }
                        })];
                }
            });
        });
    },
    getAccessToken: function (options) {
        return new Promise(function (resolve) {
            var env = environment.getApiEnv();
            var defaultOption = {
                refreshTokenKey: env + "RefreshToken",
                accessTokenKey: env + "AccessToken",
            };
            options = Object.assign({}, defaultOption, options);
            var apigateway = environment.getApigateWay();
            var refreshToken = cookie.getCookie(options.refreshTokenKey);
            var accessToken = cookie.getCookie(options.accessTokenKey);
            if (refreshToken) {
                var param = {
                    appid: options.AppID,
                    refreshtoken: refreshToken,
                };
                if (!accessToken) {
                    http({
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        url: apigateway + "/api/v1/token/refreshtoken",
                        data: qs.stringify(param),
                    }).then(function (result) {
                        if (result.data.status === 0) {
                            cookie.setCookie(options.accessTokenKey, result.data.result);
                            resolve(result.data.result);
                        }
                        else {
                            resolve({
                                info: '-1',
                            });
                        }
                    }, function (error) {
                        resolve(error);
                    });
                }
                else {
                    resolve(accessToken);
                }
            }
            else {
                resolve({
                    info: '-1',
                });
            }
        });
    },
    sleep: function (seconds) {
        if (!seconds) {
            return;
        }
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, seconds);
        });
    },
    //获取后台token
    getAdmintoken: function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getTokenLoading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sleep(10)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.getAdmintoken(options)];
                    case 2: return [2 /*return*/, new Promise(function (resolve) {
                            var apigateway = environment.getApigateWay();
                            // let apigateway = 'https://t-apigateway.gaodun.com'
                            var refreshToken = cookie.getCookie('refreshAdmintoken');
                            var accessToken = cookie.getCookie('accessAdmintoken');
                            if (refreshToken) {
                                var param = {
                                    appid: options.AppID,
                                    refreshtoken: refreshToken,
                                };
                                if (!accessToken) {
                                    _this.getTokenLoading = true;
                                    http({
                                        method: 'post',
                                        headers: {
                                            'Content-Type': 'application/x-www-form-urlencoded',
                                        },
                                        url: apigateway + "/api/v1/token/refreshtoken",
                                        data: qs.stringify(param),
                                    }).then(function (result) {
                                        _this.getTokenLoading = false;
                                        if (result.data.status == 0) {
                                            cookie.setCookie("accessAdmintoken", result.data.result);
                                            resolve(result.data.result);
                                        }
                                        else {
                                            resolve({
                                                info: '-1',
                                            });
                                        }
                                    }, function (error) {
                                        _this.getTokenLoading = false;
                                        resolve(error);
                                    });
                                }
                                else {
                                    resolve(accessToken);
                                }
                            }
                            else {
                                resolve({
                                    info: '-1',
                                });
                            }
                        })];
                }
            });
        });
    },
    getFronttoken: function (options) {
        return new Promise(function (resolve) {
            var apigateway = environment.getApigateWay();
            var refreshToken = cookie.getCookie('Refreshtoken');
            var accessToken = cookie.getCookie('Accesstoken');
            if (refreshToken) {
                var param = {
                    appid: options.AppID,
                    refreshtoken: refreshToken,
                };
                if (!accessToken) {
                    http({
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        url: apigateway + "/api/v1/token/refreshtoken",
                        data: qs.stringify(param),
                    }).then(function (result) {
                        if (result.data.status == 0) {
                            cookie.setCookie("Accesstoken", result.data.result);
                            resolve(result.data.result);
                        }
                        else {
                            resolve({
                                info: '-1',
                            });
                        }
                    }, function (error) {
                        resolve(error);
                    });
                }
                else {
                    resolve(accessToken);
                }
            }
            else {
                resolve({
                    info: '-1',
                });
            }
        });
    },
    setAdminRefreshToken: function (token) {
        cookie.setCookie('refreshAdmintoken', token, 7 * 24 * 3600);
    },
    setAdminAccessToken: function (token) {
        cookie.setCookie('accessAdmintoken', token, (3 * 24 - 1) * 3600);
    },
    setFrontRefreshToken: function (token) {
        cookie.setCookie('Refreshtoken', token, 13.5 * 24 * 3600);
    },
    setFrontAccessToken: function (token) {
        cookie.setCookie('Accesstoken', token, 2.9 * 24 * 3600);
    },
};

export default token;
